/**
 * Map Chip Interaction Handlers
 *
 * Pure event delegation — no Redux, no CSS, no business logic.
 * The plugin passes a callback; this module only routes DOM events to it.
 *
 * @param {Function} onChipSelected - Called with chipKey string when a chip is clicked
 * @returns {{ onChipClick: Function }}
 */
function createMapChipHandlers(onChipSelected) {
  return {
    onChipClick({ chipKey }) {
      onChipSelected(chipKey);
    },
  };
}

export default createMapChipHandlers;
